/* eslint-disable no-restricted-globals */
// Note: we also have the `LazyLoadingScriptService` but the DI is not accessible yet
// when polyfills are loading (they're loaded before the app is bootstrapped).
export function loadScript(src: string): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    const onLoad = () => {
      cleanup();
      resolve();
    };
    const onError = (event: ErrorEvent) => {
      cleanup();
      reject(event);
    };
    const cleanup = () => {
      script.removeEventListener('load', onLoad);
      script.removeEventListener('error', onError);
      script.remove();
    };
    script.addEventListener('load', onLoad);
    script.addEventListener('error', onError);
    document.head.appendChild(script);
  });
}
